import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;

let _wave: string | null = null;

export function initAnalytics(): void {
  if (!POSTHOG_KEY) return;
  posthog.init(POSTHOG_KEY, {
    api_host: "https://us.i.posthog.com",
    defaults: "2026-01-30",
    person_profiles: "identified_only",
    capture_pageview: false,
    persistence: "localStorage",
    autocapture: false,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: { password: true },
    },
    enable_recording_console_log: true,
  });
}

export function identifyUser(userId: string, wave: string | null): void {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId, { wave });
}

export function setCurrentWave(wave: string | null): void {
  _wave = wave;
}

export function getCurrentWave(): string | null {
  return _wave;
}

export type AppEvent =
  | { name: "app_loaded";         props: { app_version: string } }
  | { name: "login_completed";    props: { wave: string | null } }
  | { name: "retreat_opened";     props: { retreat_id: string; wave: string | null } }
  | { name: "retreat_started";    props: { retreat_id: string; wave: string | null } }
  | { name: "retreat_completed";  props: { retreat_id: string; wave: string | null } }
  | { name: "content_opened";     props: { retreat_id: string; wave: string | null } }
  | { name: "history_viewed";     props: { wave: string | null } }
  | { name: "logout";             props: { wave: string | null } }
  | { name: "feedback_opened";    props: { wave: string | null } }
  | { name: "feedback_submitted"; props: { wave: string | null; has_audio: boolean; has_screenshots: boolean; has_log: boolean } }
  | { name: "bell_played";        props: { bell_type: string; container_index: number } }
  | { name: "session_transition"; props: { from: string; to: string } }
  | { name: "payment_initiated";  props?: undefined }
  | { name: "payment_completed";  props?: undefined }
  | { name: "app_installed";      props?: undefined };

export function track<E extends AppEvent>(
  name: E["name"],
  props?: Extract<AppEvent, { name: E["name"] }>["props"],
): void {
  if (!POSTHOG_KEY) return;
  posthog.capture(name, props ?? {});
}
